import { PayloadAction } from '@reduxjs/toolkit';
import { BBox } from '@turf/helpers';
import { getValidFitBounds } from '../utils';

import { IState } from '../types/state';

const setStationsFitBounds = (state: IState, action: PayloadAction<BBox>) => {
  if (action.payload.length) {
    const fitBounds = action.payload;
    state.stations.fitBounds = getValidFitBounds(fitBounds);
  }
};

export default setStationsFitBounds;
